import { ORIGINAL_BILL_USE } from 'src/stores/billAutomation/originalBillUse';

/**
 * What apply billing's banner says when "Use the original bill for this table" does not take the original (LB-6016): why,
 * and what the person can do instead. Which outcome it is, is decideOriginalBillUse's call.
 */
export function getOriginalBillRefusal(use) {
  switch (use) {
    case ORIGINAL_BILL_USE.gone:
      return 'The original isn’t on file any more. Upload the bill again, or enter it yourself.';
    case ORIGINAL_BILL_USE.unchecked:
      return 'We couldn’t check the original just now. Try again in a moment.';
    case ORIGINAL_BILL_USE.inUse:
      return 'The original is already allocated, so it can’t be used here too. Enter this bill yourself.';
    case ORIGINAL_BILL_USE.reading:
      return 'The original is still being read. Try again in a minute.';
    case ORIGINAL_BILL_USE.unread:
      return 'The original couldn’t be read, so there’s nothing to use from it. Enter this bill yourself.';
    case ORIGINAL_BILL_USE.otherTable:
      return 'The original doesn’t charge for this utility on this property, so it can’t be used here. Enter this bill yourself.';
    case ORIGINAL_BILL_USE.billsPage:
      return 'The original is waiting on the Bills page for its property to be chosen there. Open it on the Bills page.';
    case ORIGINAL_BILL_USE.unusable:
      return 'The original can’t be used here. Enter this bill yourself.';
    default:
      return null;
  }
}